import SettingsIcon from "@mui/icons-material/Settings";
import { TableCell } from "@mui/material";

import StatusBodyshopRate from "@/main/components/shared/status/statusBodyshopRate";
import * as S from "./styles";
import { getTranslateByKey } from "@/main/services/utils";
import { RateImportStatusEnum } from "@/main/services/enum/RateImportStatusEnum";
import { RateImportResponse } from "@/main/models/response";
import { downloadFile, downloadXML } from "@/main/services/utilsFile";
import { rateImportApi } from "@/main/api";

interface IRowBodyshopRateProps {
	rate: RateImportResponse;
}

function RowBodyshopRate({ rate }: IRowBodyshopRateProps) {
	function renderLabel(value: string, width: string = "150px") {
		return (
			<S.CustomColumn $width={width} title={value}>
				{value}
			</S.CustomColumn>
		);
	}

	function handleErrorLog(guidRateImport: string) {
		rateImportApi.getErrorMessage(guidRateImport).then((response: any) => {
			downloadXML(response.data.result, rate.fileImportName);
		});
	}

	function handleDownloadImport(guidFileImport: string) {
		rateImportApi.downloadImportFile(guidFileImport).then((response: any) => {
			if (response.data.result) {
				const base64File = response.data.result;
				downloadFile(base64File, rate.fileImportName);
			}
		});
	}

	return (
		<S.Container $isSizeLong>
			<TableCell className="TableCell-SizeSmall">
				<S.ColumnLink
					onClick={() => handleDownloadImport(rate.guidFileImport)}
					id="id-bodyshopRatesImport-downloadImport-button"
				>
					{rate.fileImportName}
				</S.ColumnLink>
			</TableCell>

			<TableCell className="TableCell-SizeSmall">{renderLabel(rate.insurerName)}</TableCell>

			<TableCell className="TableCell-SizeMedium">
				{renderLabel(`${rate.userName} - ${rate.dateImport}`, "100%")}
			</TableCell>

			<TableCell className="TableCell-Status">
				<S.CustomColumn $width="120px" title={rate.statusName}>
					<StatusBodyshopRate idStatus={rate.idRateImportStatus} name={rate.statusName} />
				</S.CustomColumn>
			</TableCell>

			<TableCell className="TableCell-SizeActions" style={{ textAlign: "center" }}>
				{rate.idRateImportStatus !== RateImportStatusEnum.Success && (
					<S.ErrorLogButton
						onClick={() => handleErrorLog(rate.guidRateImport)}
						id="id-bodyshopRatesImport-errorLog-button"
					>
						<SettingsIcon />
						{getTranslateByKey("information.errorLog")}
					</S.ErrorLogButton>
				)}
			</TableCell>
		</S.Container>
	);
}

export default RowBodyshopRate;
